import React, { useId } from "react";
export function TalaveraDivider({
  className = ""
}: {
  className?: string;
}) {
  const patternId = `talavera-${useId().replace(/:/g, "")}`;
  return <div aria-hidden="true" className={`border-y-2 border-talavera bg-cream ${className}`} data-id="element-133" data-mp="o75ipe51s1jv">
      <svg className="block h-7 w-full sm:h-8" preserveAspectRatio="none" data-id="element-134" data-mp="j7sp8ajo7w8b">
        <defs data-id="element-135" data-mp="e86atxs3w9xx">
          <pattern id={patternId} width="28" height="28" patternUnits="userSpaceOnUse" data-id="element-136" data-mp="e8psrehrayby">
            <rect width="28" height="28" fill="#FBF3E4" data-id="element-137" data-mp="1btkdql4b62z0" />
            {[0, 90, 180, 270].map(angle => <path key={angle} d="M14 3C17 7.5 17 9.5 14 13C11 9.5 11 7.5 14 3Z" fill="#1F4E9C" transform={`rotate(${angle} 14 14)`} data-id="element-138" data-mp="16xdj3ohd4dwd" />)}
            <circle cx="14" cy="14" r="2.4" fill="#E8871E" data-id="element-139" data-mp="1uklb54ps5qgg" />
            <circle cx="0" cy="0" r="3.6" fill="#1CA7A8" data-id="element-140" data-mp="1um65at86n7ds" />
            <circle cx="28" cy="0" r="3.6" fill="#1CA7A8" data-id="element-141" data-mp="1ptv5rrhctnlr" />
            <circle cx="0" cy="28" r="3.6" fill="#1CA7A8" data-id="element-142" data-mp="1psbpw1zm1eki" />
            <circle cx="28" cy="28" r="3.6" fill="#1CA7A8" data-id="element-143" data-mp="3dgjdnjrd5ooj" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${patternId})`} data-id="element-144" data-mp="3hfsawylm44ou" />
      </svg>
    </div>;
}